<template>
  <v-container>
    <v-row>
      <v-col sm="12">
        <h1>You must change your password</h1>
      </v-col>
      <v-col
        cols="12"
        md="6"
        md-offset="3"
      >
        <v-form
          ref="form"
          @submit.prevent="handleSubmit()"
        >
          <v-container fluid>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="currentPassword"
                  required
                  :rules="[required]"
                  label="Current Password"
                  clearable
                  name="current_password"
                  type="password"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="password"
                  required
                  :rules="[required]"
                  label="New Password"
                  clearable
                  name="password"
                  type="password"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="reenterPassword"
                  required
                  :rules="[required, mustMatchPassword]"
                  label="Re-enter Password"
                  clearable
                  name="password"
                  type="password"
                />
              </v-col>
              <v-col cols="12">
                <v-btn
                  type="submit"
                  name="submit"
                >
                  Change Password
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
// @ is an alias to /src

export default {
  name: 'Changepassword',
  components: {
    
  },
  data () {
    return {
        password: '',
        reenterPassword: '',
        currentPassword: '',
    }
  },
  methods: {
    required (value) {
        return value !== '' ? true : 'Required'
    },
    mustMatchPassword (value) {
        return value === this.password ? true : 'Must match password.' 
    },
    validateBeforeSubmit () {
        return this.required(this.currentPassword) === true && this.required(this.password) === true && this.required(this.reenterPassword) === true && this.mustMatchPassword(this.reenterPassword) === true
    },
    handleSubmit () {
        const { password, currentPassword } = this
        const passwordObject = {
            new_password: password, current_password: currentPassword
        }
        // straight up pretend we could change the password
        // don't forget to send the token from the store as the authorization header

        if (this.validateBeforeSubmit()) {
            axios({
                method: 'post',
                url: `${this.$store.getters.baseURL}/api/user/change_password/`,
                data: passwordObject,
                headers: {
                    'Authorization': `Token ${this.$store.state.userToken}`
                }
            })
            .then(() => {
                console.info('Successfully changed password...')
                this.$router.push('/')
            })
            .catch(err => {
                console.error(err)
            }) 
        }
    }
  }
}
</script>
